import { jsonldName } from './JsonldStore';

export const updateJsonldName = (value) => jsonldName.update((oldValue) => value);

